/** Внутри есть `trim()`: для строк, из которых считается ключ (`cartLineKey`), не годятся. */

export function clampText(value: string, max: number): string {
  return value.trim().slice(0, max);
}

/** Пустая строка и мусор нетипичного типа дают null — модель хранит только `string | null`. */
export function optionalText(value: unknown, max: number): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const text = clampText(value, max);
  return text.length > 0 ? text : null;
}
